import type { SolutionSector } from "../sectors";
import { ACCESS_QUESTION, COST_QUESTION, EFFORT_QUESTION, HOSTING_QUESTION, LOGO } from "./shared";

export const CREATIVE_MEDIA: SolutionSector = {
  slug: "creative-media",
  name: "Creative & media",
  demoOrg: "Demo (Creative + Media)",
  story: "creative",
  metadata: {
    title: "AI for production readiness in creative studios | Your Twin",
    description:
      "See which jobs have open decisions or supplier queries before production starts. Your Twin connects Google Drive, Google Sheets, Xero and Slack.",
  },
  hero: {
    label: "Creative & media",
    title: ["Settle the open", "details before", "production."],
    lead: [
      "Before production starts, see which jobs still have open decisions or supplier queries. Your Twin connects briefs in ",
      LOGO.drive,
      ", trackers in ",
      LOGO.sheets,
      ", bills in ",
      LOGO.xero,
      " and messages in ",
      LOGO.slack,
      ".",
    ],
    cta: "Bring a production handover",
    buyer: "For studio founders, heads of production and executive producers",
    instrumentLabel: "The production Twin · Job, brief, supplier and producer",
  },
  replay: {
    title: "What’s still open\nbefore next week?",
    lead: "Ask across the briefs, the tracker, supplier bills and the client’s messages. See each open detail beside its start date and producer.",
  },
  outcomes: {
    title: "A clear handover\nbefore work begins.",
    lead: "Producers see what is decided, what is still open and who owns it, from the records your studio already keeps.",
    items: [
      { title: "Find the missing detail.", body: "Check the brief and the production tracker together.", show: "status" },
      { title: "Bring client changes forward.", body: "See unresolved changes and supplier queries before the work starts.", show: "sources" },
      { title: "Keep the decision with production.", body: "Give the producer the evidence behind each open point.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose a production handover that takes too long to prepare." },
  questions: [
    { q: "Does it review creative quality?", a: "No. This workflow checks recorded details and decisions. Creative judgement stays with your team and your client." },
    {
      q: "Can it compare a brief with the schedule and budget?",
      a: "Where the documents can be read and matched reliably. We test your own examples before making it part of the workflow.",
    },
    ACCESS_QUESTION,
    HOSTING_QUESTION,
    EFFORT_QUESTION,
    COST_QUESTION,
  ],
  closing: "Start with one production handover\nthat takes too long.",
};
